import WarningMsg from 'components/WarningMsg';
import { platformTypeOptions } from 'constants/annotator';
import React from 'react';
import {
  getActiveLanguageMatcher,
  getActiveLanguageMatcherId,
  getCompareMode,
  getShouldDisableEdit,
  saveIdentifierRequestLoading,
  unsavedChanges,
} from 'selectors/identifier';
import { useSelector } from 'store';
import { languageMatcherNotificationMsgs } from 'utils/userNotificationMsgs';
import DeleteMatcherButton from '../DeleteMatcherButton';
import LanguageMatcherHeader from '../LanguageMatcherHeader';
import MultiSelectField from '../shared/MultiSelectField';

type Props = { isSaved: boolean };

const MetadataCommunicationForm: React.FC<Props> = ({ isSaved }) => {
  const unsaved = useSelector(unsavedChanges);
  const isLoadingSaveIdentifier = useSelector(saveIdentifierRequestLoading);
  const compareMode = useSelector(getCompareMode);
  const shouldDisable = useSelector(getShouldDisableEdit);
  const activeLanguageMatcher = useSelector(getActiveLanguageMatcher);
  const activeLanguageMatcherId = useSelector(getActiveLanguageMatcherId);

  return (
    <div className="flex flex-col pt-5 pl-10 pr-4 pb-6 text-body h-full">
      <div className="flex flex-row justify-end">
        <WarningMsg
          message={languageMatcherNotificationMsgs.unsavedChanges}
          showLoading={isLoadingSaveIdentifier}
          showWarning={unsaved}
          showSavedMsg={isSaved}
        />
      </div>

      <div className="-mt-4 flex flex-col gap-4 text-body h-full">
        <LanguageMatcherHeader />

        <div className="mt-6">
          <MultiSelectField
            label="Types to match"
            languageMatcherId={activeLanguageMatcherId}
            parentType="metadata_communication"
            field="communication_kind"
            options={platformTypeOptions}
            value={activeLanguageMatcher.communication_kind as string[] | undefined}
            widthClassName="w-60"
            compareMode={compareMode}
            shouldDisable={shouldDisable}
          />
        </div>

        <div className="mt-auto pt-6 flex flex-row justify-end">
          <DeleteMatcherButton
            text="Delete Matcher"
            setValue={(): void => {
              // moot
            }}
            setHighlightedLanguageMatcher={(): void => {
              // moot
            }}
            activeLanguageMatcher={activeLanguageMatcher}
          />
        </div>
      </div>
    </div>
  );
};

export default MetadataCommunicationForm;
